<asl-google-signin-button type='standard' size='large' shape="circle" [width]="250" [locale]="currentLang"></asl-google-signin-button>
